<app-navigation></app-navigation>
<router-outlet></router-outlet>
<app-gainsight></app-gainsight>